import { gql } from "apollo-boost";

export const OPTIONS = gql`
  query Options($where: OptionWhereInput) {
    items: options(where: $where) {
      id
      name
      value
      type
    }
  }
`;

export const GET_PROFILE = gql`
  query GetProfile($where: ProfileWhereUniqueInput!, $where2: UserWhereInput) {
    profile: getProfile(where: $where) {
      id
      name
      layoutsId
      doctorProfiles {
        centerId
        centerName
        profileId
        profileName
        isAdmin
        medicalStaffId
        branchOfficeName
        branchOfficeId
        enabled
        userId
        fullName
        genderId
      }

      views {
        name
      }
    }
    user: getUser2(where: $where2) {
      id
      email
      username
      firstName
      lastName
      branchOffice {
        id
        name
      }
    }
    pharmacy: getPharmacyProviderLogo {
      id
      name
      commercialName

      fileLogo: pharmacyProviderLogo {
        id
        name
        path
        mimetype
      }
    }
  }
`;

export const GET_VALIDATION_EXPIRE = gql`
  query getValidationCardsToExpire($where: WhereUserServicesInput) {
    getValidationCardsToExpire(where: $where) {
      userId
      hasExpire
      hasErrorPayment
      hasBloqued
      expireMessage
      errorPaymentMessage
      cardsToExpire {
        paymentProfileId
        brand
        cardOwner
        expiration
        lastFourDigits
        default
        enabled
      }
    }
  }
`;
